import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import type { User } from '#users';

import { Uri } from '#constants/uri';

/**
 * Validates the current user session by making a GET request to the authentication endpoint.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @returns A promise that resolves to the authenticated {@link User} object if the session is valid.
 * @throws Will throw an error if the request fails or the session is invalid.
 */
export async function validateSession(instance: KyInstance) {
  try {
    return await instance.get<OperationResultWithData<User>>(Uri.authentication.validateSessions).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
}
